/**
 * Landesübliche Beschriftung der Steuer-Identifikationsnummer auf Dokumenten
 * (Rechnungs-/Brief-Footer, Unternehmensdaten-Formular).
 *
 * Schweizer und österreichische Nummern heißen offiziell "UID" (CHE-… bzw. ATU…),
 * die deutsche USt-IdNr. bleibt "Ust.-ID". Primärsignal ist die Nummer selbst,
 * da deren Präfix normiert ist; Fallback ist das Freitext-Land aus den
 * Unternehmensdaten (Prod-Bestand: "Deutschland", "Schweiz", "Österreich",
 * "DE", "Östereich", leer — daher Schreibweisen-Liste statt Enum).
 */
const UID_COUNTRIES = [
    "schweiz",
    "suisse",
    "svizzera",
    "switzerland",
    "ch",
    "österreich",
    "oesterreich",
    "osterreich",
    "östereich",
    "austria",
    "at",
];

export const isUidTaxId = (taxId?: string | null, country?: string | null): boolean => {
    const id = (taxId ?? "").trim().toUpperCase();

    if (id.startsWith("CHE") || id.startsWith("ATU")) {
        return true;
    }

    return UID_COUNTRIES.includes((country ?? "").trim().toLowerCase());
};

export const getTaxIdLabel = (taxId?: string | null, country?: string | null): string =>
    isUidTaxId(taxId, country) ? "UID" : "Ust.-ID";
